import { HelpCenter } from '@hai/ui-react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RELEASE_NOTES_URL, SUPPORT_PORTAL_URL, SUPPORT_URL } from 'src/js/constant';
import { openNewWindow } from 'src/js/util/global-util';
import bgMK from 'src/images/help-center-bg.jpg';
import { useModalControls } from 'src/js/hook/use-modal-controls';
import { WhatsNewModal } from 'src/js/whatsNew/WhatsNewModal';
import helpStore from 'src/js/store/help-store';
import { APIPath } from 'src/js/api/route-path-index';
import { apiClientWithoutHandler } from 'src/js/api';
import { getInfoCenterURL, infoCenterHelpExists } from 'src/js/util/online-status-util';
import { useStores } from 'src/js/hook/use-stores';
import { useMutable } from 'src/js/hook/use-mutable';

export const HelpPage = () => {
  const { t } = useTranslation();
  const isOnlineStoreValue = helpStore.online;
  const [isOnline, setOnline] = useState(true); // use default true to not flash an offline banner for a split second
  const [onlineCheckCompleted, setOnlineCheckCompleted] = useMutable(isOnlineStoreValue); // if sidebar already found that we are online, consider the check done
  const { sessionStore } = useStores();

  useEffect(() => {
    // doc.haivision.com check routine
    infoCenterHelpExists((err) => {
      // console.log('online status', err);
      setOnlineCheckCompleted(true);
      if (!err) {
        helpStore.online = true;
        setOnline(true);
      } else {
        helpStore.online = false;
        setOnline(false);
      }
    });

    setTimeout(() => {
      if (!onlineCheckCompleted()) {
        setOnline(false); // if after 2 seconds we still havent seen the online status from sidebar and local fetch, then assume offline until we get a response.
      }
    }, 2000);
  }, []);

  const handleHelpClick = () => {
    if (helpStore.online) {
      apiClientWithoutHandler.genericController.get(APIPath.status.get).then((res: any) => {
        if (res.ok && res.data.firmwareVersion) {
          const version = res.data.firmwareVersion.replace(/(.*)-.*/, '$1');
          openNewWindow(getInfoCenterURL('MakitoX4Dec', version, sessionStore.isAdmin()));
        } else {
          openNewWindow('/help/makitox/index.html', 'mk-help');
        }
      });
    } else {
      openNewWindow('/help/makitox/index.html', 'mk-help');
    }
  };

  const [whatsNewShown, showWhatsNew, hideWhatsNew] = useModalControls();
  const handleClickCard = (eventKey: string) => {
    switch (eventKey) {
      case 'release-notes':
        openNewWindow(RELEASE_NOTES_URL);
        break;
      case 'documentation-center':
        handleHelpClick();
        break;
      case 'support-ticket':
        openNewWindow(SUPPORT_URL);
        break;
      case 'support-portal':
        openNewWindow(SUPPORT_PORTAL_URL);
        break;
      case 'whats-new':
        showWhatsNew();
        break;
    }
  };
  return (
    <>
      <div id="help-center" className="sidebarLayout">
        <HelpCenter
          accentColor={'haiui-aqua-01'}
          backgroundImage={bgMK}
          offlineMode={!isOnline}
          className="pageContent"
        >
          <HelpCenter.Header caption={t('helpCenter.header')} />
          <HelpCenter.Title caption={t('helpCenter.title')} description={t('helpCenter.description')} />
          <HelpCenter.ButtonBar
            offlineWarning={{
              text: t('helpCenter.offlineWarningStart') + '{{link}}' + t('helpCenter.offlineWarningEnding'),
              linkText: 'Haivision.com',
              linkUrl: 'https://www.haivision.com/',
            }}
          ></HelpCenter.ButtonBar>
          <HelpCenter.Cards>
            <HelpCenter.Card
              caption={t('helpCenter.whatsNew')}
              eventKey="whats-new"
              icon="WhatsNew"
              onClick={handleClickCard}
              disabled={false}
            />
            <HelpCenter.Card
              caption={t('helpCenter.documentationCenter')}
              eventKey="documentation-center"
              onClick={handleClickCard}
              icon="Documentation"
              disabled={false}
            />
            <HelpCenter.Card
              caption={t('helpCenter.openSupportTicket')}
              eventKey="support-ticket"
              icon="SupportTicket"
              onClick={handleClickCard}
            />
            <HelpCenter.Card
              caption={t('helpCenter.supportPortal')}
              eventKey="support-portal"
              icon="SupportPortal"
              onClick={handleClickCard}
            />
            {/* We dont have release notes link available R4KD-2561
              <HelpCenter.Card
              caption={t('helpCenter.releaseNotes')}
              eventKey="release-notes"
              icon="Index"
              onClick={handleClickCard}
            />*/}
          </HelpCenter.Cards>
          <HelpCenter.Contacts sectionTitle={t('helpCenter.contactUs')}>
            <HelpCenter.Contact
              caption={t('helpCenter.northAmericaSupport')}
              contactInfo={[
                {
                  phone: t('helpCenter.northAmericaSupportPhone'),
                },
              ]}
            />
            <HelpCenter.Contact
              caption={t('helpCenter.franceSupport')}
              contactInfo={[
                {
                  phone: t('helpCenter.franceSupportPhone'),
                },
              ]}
            />
            <HelpCenter.Contact
              caption={t('helpCenter.ukSupport')}
              contactInfo={[
                {
                  phone: t('helpCenter.ukSupportPhone'),
                },
              ]}
            />
            <HelpCenter.Contact
              caption={t('helpCenter.allOthersSupport')}
              contactInfo={[
                {
                  phone: t('helpCenter.allOthersSupportPhone'),
                },
              ]}
            />
          </HelpCenter.Contacts>
        </HelpCenter>
      </div>
      {whatsNewShown && <WhatsNewModal onCancel={hideWhatsNew} />}
    </>
  );
};
